import '../Navbar/Navbar.css'
import Gatisheellogo from './Gatisheel logo.png';
import Navtab1 from '../Navbar/Navtab1';
import Navtab2 from '../Navbar/Navtab2';
import Navtab3 from '../Navbar/Navtab3';

const Mnavbar = () => 
{
return<>
<nav className="navbar bg-success" aria-label="Light offcanvas navbar">
  <div className="container-fluid" style ={{width:'100%', height:'auto'}}>
      <img src={Gatisheellogo} style={{width: '60px', height: '60px'}} alt=" "/>
      <a className="navbar-brand custom-margin1" href="https://www.gatisheel.com/" style = {{color: 'white', fontSize: '30px', fontWeight: 'bold'}}>GATISHEEL </a>
      <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbarLight" aria-controls="offcanvasNavbarLight" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbarLight" aria-labelledby="offcanvasNavbarLightLabel">
        <div className="offcanvas-header custom-margin1">
          <h5 className="offcanvas-title" id="offcanvasNavbarLightLabel">GATISHEEL</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body bg-success">
          <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                        <Navtab1/>
                        <Navtab2/>
                        <Navtab3/>
          </ul>
          {/* <form className="d-flex mt-3 custom-margin1" role="search">
            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
            <button className="btn btn-outline-success" type="submit">Search</button>
          </form> */}
           <ul className="navbar-nav mb-2 mb-lg-0">
                            <li className="nav-item">
                                <span className="nav-link" > Enquire Now</span>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://wa.me/+919518802185" target="_blank " rel="noreferrer" ><i className="fa-brands fa-whatsapp fa-2x"></i></a>
                            </li>
            </ul>
        </div>
      </div>
    </div>
  </nav>
  </>
};
export default Mnavbar;
